import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export const SecurityPanel = ({ user, onChanged }) => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.next.length < 8 || !/\d/.test(f.next) || !/[a-zA-Z]/.test(f.next)) return setErr("A nova senha precisa ter pelo menos 8 caracteres, com letras e números.");
    if (f.next !== f.confirm) return setErr("A confirmação não confere com a nova senha.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Senha alterada com sucesso");
      setF({ current: "", next: "", confirm: "" });
      onChanged();
    } catch (error) { setErr(formatApiError(error.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="panel-card space-y-4 max-w-md" data-testid="security-panel">
      <div className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#10B981]" /><h2 className="font-heading text-base md:text-lg font-semibold">Minha conta · Alterar senha</h2></div>
      <p className="text-xs text-[#9CA3AF]">Conta: <span className="font-mono">{user.email}</span></p>
      {user.must_change_password && <p className="text-sm text-amber-300 flex gap-2" data-testid="must-change-warning"><ShieldAlert className="w-4 h-4 shrink-0" />A senha inicial foi exposta. Troque agora para continuar usando o painel.</p>}
      <Input type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} placeholder="Senha atual" className="input-dark h-11" data-testid="current-password-input" required />
      <Input type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} placeholder="Nova senha (mín. 8, letras e números)" className="input-dark h-11" data-testid="new-password-input" required />
      <Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="Confirmar nova senha" className="input-dark h-11" data-testid="confirm-password-input" required />
      {err && <p className="text-sm text-red-400" data-testid="change-password-error">{err}</p>}
      <Button type="submit" disabled={busy} className="btn-primary h-11 w-full" data-testid="change-password-submit">{busy ? "Salvando..." : "Alterar senha"}</Button>
    </form>
  );
};
